"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
/**
 * Filters out unrecognized props based on the provided propTypes.
 * Needed in case when you not sure that only acceptable props are provided to the component.
 *
 * @param {object} props - The input props object.
 * @param {object} propTypes - The propTypes object used for filtering.
 * @return {object} The filtered props object containing only recognized props.
 */
const useRecognizedProps = (props, propTypes) => {
  const recognizedProps = (0, _react.useMemo)(() => Object.keys(props).reduce((recognizedProps, propName) => {
    if (propTypes[propName]) {
      recognizedProps[propName] = props[propName];
    }
    return recognizedProps;
  }, {}), [props, propTypes]);
  return recognizedProps;
};
var _default = exports.default = useRecognizedProps;